<template>
  <div class="ProjectEdit" v-if="project && project.uuid">
    <help-message>
      <h3 slot="title">Édition d'un projet</h3>
      <p>
        Sur cette page, vous pouvez éditer un projet.<br />Vous ne pouvez pas
        quitter cette page par erreur sans en être prévenu, et ainsi avoir
        l'occasion de sauvegarder vos changements.<br />Sans sauvegarde de votre
        part, le projet reste inchangé.
      </p>
    </help-message>
    <h2>Éditer un projet ({{ project.name }})</h2>
    <hr />
    <ProjectEdit-Main :item="project" @update="project = $event" />
    <ProjectEdit-Locality :item="project" @update="project = $event" />
    <ProjectEdit-Nature :item="project" @update="project = $event" />
    <ProjectEdit-Context :item="project" @update="project = $event" />
    <ProjectEdit-Interlocuteurs :item="project" @update="project = $event" />
    <ProjectEdit-Dates :item="project" @update="project = $event" />
    <ProjectEdit-SurfaceCost :item="project" @update="project = $event" />
    <ProjectEdit-Specificities :item="project" @update="project = $event" />
    <ProjectEdit-Axes :item="project" @update="project = $event" />
    <hr />
    <div>
      <div class="buttons">
        <button
          class=" button is-primary"
          :class="loading ? 'is-loading' : ''"
          @click="save"
        >
          Enregistrer
        </button>
      </div>
      <p v-show="hasError" class="has-text-danger">
        Une erreur est survenue. Vérifiez le formulaire.
      </p>
    </div>
  </div>
</template>

<script>
import { types as t } from "../../store/actions/projects";
import { types as contactTypes } from "../../store/actions/contacts";
import { hasId } from "../../store/models/_helpers";
import { Project, prepareProjectBeforeSend } from "../../store/models/project";
import ProjectEditSurfaceCost from "./Edit/ProjectEditSurfaceCost";
import ProjectEditSpecificities from "./Edit/ProjectEditSpecificities";
import ProjectEditContext from "./Edit/ProjectEditContext";
import ProjectEditNature from "./Edit/ProjectEditNature";
import ProjectEditLocality from "./Edit/ProjectEditLocality";
import ProjectEditMain from "./Edit/ProjectEditMain";
import ProjectEditInterlocuteurs from "./Edit/ProjectEditInterlocuteurs";
import ProjectEditDates from "./Edit/ProjectEditDates";
import { setSaveState } from "../../util/func";
import ProjectEditAxes from "./Edit/ProjectEditAxes";
import HelpMessage from "../../components/Form/HelpMessage";

export default {
  name: "ProjectEdit",
  components: {
    HelpMessage,
    ProjectEditAxes,
    ProjectEditDates,
    ProjectEditInterlocuteurs,
    ProjectEditMain,
    ProjectEditLocality,
    ProjectEditNature,
    ProjectEditContext,
    ProjectEditSpecificities,
    ProjectEditSurfaceCost
  },
  props: {
    uuid: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      project: {},
      loading: false,
      hasError: false
    };
  },
  methods: {
    async save() {
      this.loading = true;
      setTimeout(async () => {
        try {
          await this.$store.dispatch(
            t.UPDATE_PROJECT,
            prepareProjectBeforeSend(this.project)
          );
          setSaveState(this.$router);
          this.loading = false;
          this.hasError = false;
        } catch (e) {
          this.hasError = true;
          this.loading = false;
        }
      }, 500);
    },
    async displayAddContact(contact) {
      if (!hasId(this.project.contacts, contact)) {
        this.project.contacts.push(
          await this.$store.dispatch(contactTypes.GET_CONTACT_BY_ID, contact)
        );
      }
    }
  },
  async mounted() {
    this.project = new Project(
      await this.$store.dispatch(t.GET_PROJECT_BY_UUID, {
        uuid: this.uuid
      })
    );
  }
};
</script>

<style lang="scss">
.ProjectEdit {
  &__part {
    margin: 1em 0;
  }
  textarea,
  textarea.textarea {
    font-size: 0.85em;
    font-family: inherit;
  }

  button.is-danger {
    background: lightgray;
    color: #666;
  }

  .VioletBar {
    margin-top: 2.5em;
  }
}

.ProjectContacts {
  padding: 16px;
  border-radius: 3px;
  margin: 1em 0;
}
</style>
